import React, { useState, useEffect, useMemo } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import ShowAlert from "../common/Showalert";
import RichTextEditor from "../common/richTextEditor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import moment from "moment";
import Popup from "../common/popup";
import { useTranslation } from "react-i18next";
import EmailDynamicContentInfo from "../common/emailDynamicContentInfo";
import ConfirmationPopup from "../common/confirmationPopup";
import AlertPopup from "../common/alertPopup";
import { dateformatwithuktime } from "../utilityfunctions";
import { format } from "date-fns";

const EditEmailCampaign = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const campaignData = location.state?.campaignData;
  const viewOnly = location.state?.viewOnly || false;
  const campaignId = campaignData?._id;
  const [isLoading, setIsLoading] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alerterrMessage, setAlerterrMessage] = useState("");
  const [emailCampaignName, setEmailCampaignName] = useState("");
  const [emailType, setEmailType] = useState("logged_in_not_order");
  const [accountFilter, setAccountFilter] = useState(24);
  const [customHoursFilter, setCustomHoursFilter] = useState("");
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [emailData, setEmailData] = useState({});
  const [errors, setErrors] = useState({});
  const [showReminderEmail, setShowReminderEmail] = useState(false);
  const [reminderInterval, setReminderInterval] = useState(0);
  const [reminderCountLimit, setReminderCountLimit] = useState(0);
  const [sendHeader, setSendHeader] = useState(false);
  const [sendFooter, setSendFooter] = useState(false);
  const [reminderHeader, setReminderHeader] = useState(false);
  const [reminderFooter, setReminderFooter] = useState(false);
  const [isEmailAccordionOpen, setIsEmailAccordionOpen] = useState(true);
  const [isReminderAccordionOpen, setIsReminderAccordionOpen] = useState(true);
  const [scheduledDateTime, setScheduledDateTime] = useState(null);
  const [campaignNameError, setCampaignNameError] = useState("");
  const [rowToDelete, setRowToDelete] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [dateTimeError, setDateTimeError] = useState("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [confirmActionType, setConfirmActionType] = useState("");
  const [emailEntryId, setEmailEntryId] = useState("");
  const [statusPopup, setStatusPopup] = useState({
    show: false,
    row: null,
    message: "",
  });
  const [originalReminderData, setOriginalReminderData] = useState({
    reminderEmailSubject: "",
    reminderEmailContent: "",
    reminderInterval: 0,
    reminderCountLimit: 0,
    header: false,
    footer: false,
  });
  const [showMinCustomerAlert, setShowMinCustomerAlert] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [selectedAccountsInternal, setSelectedAccountsInternal] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [currentReminderCount, setCurrentReminderCount] = useState(0);
  const [currentReminderCountforLimit, setCurrentReminderCountforLimit] =
    useState(0);
  const intervalOptions = [24, 48, 96];
  const [isCustomInterval, setIsCustomInterval] = useState(false);
  const [customIntervalValue, setCustomIntervalValue] = useState("");
  const [showStatusConfirmPopup, setShowStatusConfirmPopup] = useState(false);
  const [bulkMode, setBulkMode] = useState(false);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [showBulkStatusPopup, setShowBulkStatusPopup] = useState(false);
  const isDraft = emailData.status === "draft";
  const [pendingFilter, setPendingFilter] = useState(null);
  const [customHoursError, setCustomHoursError] = useState("");
  const [pendingCustomHours, setPendingCustomHours] = useState("");
  const [customHours, setCustomHours] = useState("");
  const [filter, setFilter] = useState("");
  const [originalEmailType, setOriginalEmailType] = useState("");
  const [originalCutoff, setOriginalCutoff] = useState("");
  const [hasUserModified, setHasUserModified] = useState(false);
  const [showQueuedPopup, setShowQueuedPopup] = useState(false);
  const [queuedPopupData, setQueuedPopupData] = useState(null);
  const [queuedLoading, setQueuedLoading] = useState(false);
  const [selectedAccountCode, setSelectedAccountCode] = useState("");

  const [schedules, setSchedules] = useState([]);

  const [isScheduleRequired, setIsScheduleRequired] = useState(false);
  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    http
      .get(BaseUrl + "admin/holidays")
      .then((response) => {
        const dates = response.data.data.map((h) =>
          new Date(h.holidayDate).setHours(0, 0, 0, 0)
        );
        setHolidays(dates);
      })
      .catch((err) => console.log(err));
  }, []);

  // --- Fetch campaign by ID ---
  useEffect(() => {
    if (!campaignId) return;
    setIsLoading(true);
    http
      .get(`${BaseUrl}admin/getEmailEntriesByCampaignId/${campaignId}`)
      .then((res) => {
        if (res.data.success && res.data.data) {
          const data = res.data.data;
          setEmailCampaignName(data.emailCampaignName || "");
          setEmailType(data.emailType || "logged_in_not_order");
          setOriginalEmailType(data.emailType || "logged_in_not_order");
          // setAccountFilter(Number(data.cutoffTime) || 24);
          // setCustomHoursFilter(data.cutoffTime || "");
          if (
            data.cutoffTime === "custom" ||
            Number(data.cutoffTime) > 96 ||
            ![24, 48, 96].includes(Number(data.cutoffTime))
          ) {
            setPendingFilter("custom");
            setPendingCustomHours(Number(data.cutoffTime));
            setAccountFilter("custom");
            setCustomHoursFilter(Number(data.cutoffTime));
            setOriginalCutoff(Number(data.cutoffTime));
          } else {
            setPendingFilter(Number(data.cutoffTime));
            setPendingCustomHours("");
            setAccountFilter(Number(data.cutoffTime));
            setCustomHoursFilter("");
            setOriginalCutoff(Number(data.cutoffTime));
          }
          setSelectedAccounts(data.emailEntries || []);
          setEmailData({
            emailSubject: data.emailSubject || "",
            emailContent: data.emailContent || "",
            reminderEmailSubject: data.reminderEmailSubject || "",
            reminderEmailContent: data.reminderEmailContent || "",
            status: data.status || "",
            autoEmail: data.autoEmail || false,
            runStatus: data.runStatus,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
          });
          setOriginalReminderData({
            reminderEmailSubject: data.reminderEmailSubject || "",
            reminderEmailContent: data.reminderEmailContent || "",
            reminderInterval: data.reminderInterval ?? 0,
            reminderCountLimit: data.reminderCountLimit ?? 0,
            header: data.header || false,
            footer: data.footer || false,
          });
          setReminderInterval(data.reminderInterval ?? 0);
          setReminderCountLimit(data.reminderCountLimit ?? 0);
          setShowReminderEmail((data.reminderInterval ?? 0) > 0);
          setSendHeader(data.header || false);
          setSendFooter(data.footer || false);
          setReminderHeader(data.header || false);
          setReminderFooter(data.footer || false);
          setScheduledDateTime(
            data.scheduledSendTime ? new Date(data.scheduledSendTime) : null
          );
          // Check if reminderInterval is a predefined option or custom
          if (
            data.reminderInterval &&
            !intervalOptions.includes(data.reminderInterval)
          ) {
            setIsCustomInterval(true);
            setCustomIntervalValue(data.reminderInterval);
          } else {
            setIsCustomInterval(false);
            setCustomIntervalValue("");
          }

          const reminderCount =
            data.emailEntries?.length > 0
              ? Math.max(
                  ...data.emailEntries.map((acc) => acc.reminderCount || 0)
                ) - 2
              : -1;
          setCurrentReminderCount(reminderCount);
          const limtReminderCount =
            data.emailEntries?.length > 0
              ? Math.max(
                  ...data.emailEntries.map((acc) => acc.reminderCount || 0)
                ) - 1
              : 0;

          setCurrentReminderCountforLimit(limtReminderCount);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [campaignId]);

  useEffect(() => {
    // setSchedules(["date1", "date2"]);
    if (scheduledDateTime !== "") {
      http
        .post(BaseUrl + "admin/getSchedules", {
          scheduledSendTime: scheduledDateTime,
          camapignId: campaignId,
          intervalHours: reminderInterval,
          reminderLimit: reminderCountLimit,
        })
        .then((response) => {
          setSchedules(response.data.data);
        })
        .catch((err) => console.log(err));
    }
  }, [scheduledDateTime]);

  const handleToggleAccount = (account) => {
    if (account.alreadyQueued) return;
    const isSelected = selectedAccountsInternal.some(
      (acc) => acc.accountCode === account.accountCode
    );
    let updatedSelection;
    if (isSelected) {
      updatedSelection = selectedAccountsInternal.filter(
        (acc) => acc.accountCode !== account.accountCode
      );
    } else {
      updatedSelection = [...selectedAccountsInternal, account];
    }
    setSelectedAccountsInternal(updatedSelection);
  };

  const handleToggleSelectAll = () => {
    const notQueued = customerList.filter((acc) => !acc.alreadyQueued);
    if (selectAll) {
      // Unselect all
      setSelectedAccountsInternal([]);
      setSelectAll(false);
    } else {
      // Select all that are not already queued
      setSelectedAccountsInternal(notQueued);
      setSelectAll(true);
    }
  };

  const handleAddCustomer = async () => {
    if (!emailType) {
      return;
    }
    // get cutoff hours (prefilled value)
    const cutoffHours = customHoursFilter || accountFilter;
    if (!cutoffHours) {
      setAlerterrMessage([t("cutoff_hours_missing_error_txt")]);
      setAlertErrorPopup(true);
      return;
    }
    setShowCustomerPopup(true);
    setPopupLoading(true);
    let URL2 = "";
    if (emailType === "logged_in_not_order") {
      URL2 = BaseUrl + "admin/getLoggedInNotOrdered";
    } else if (emailType === "logged_in_not_order_cutoff") {
      URL2 = BaseUrl + "admin/getLoggedInButNotOrderedCutOff";
    } else if (emailType === "abandoned_cart") {
      URL2 = BaseUrl + "admin/getAbandonedCart";
    } else {
      setPopupLoading(false);
      setAlerterrMessage(t("invalid_emailtype_txt"));
      setAlertErrorPopup(true);
      return;
    }
    try {
      const payload = { filterBy: cutoffHours };
      const res = await http.post(URL2, payload);
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        const normalized = res.data.data.map((cust) => ({
          ...cust,
          toEmail: cust.accountEmail || "",
        }));
        const filtered = normalized.filter(
          (cust) =>
            !selectedAccounts.some(
              (sel) => sel.accountCode === cust.accountCode
            )
        );
        setCustomerList(filtered);
      } else {
        setCustomerList([]);
      }
    } catch (err) {
      console.error(t("customer_fetch_err_txt"), err);
      setCustomerList([]);
    } finally {
      setPopupLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };
  const customerColumns = [
    {
      name: (
        <div className="full-text-toggle custom_check-box">
          <div className="check-box no-strike">
            <input
              type="checkbox"
              id="selectAllHeader"
              checked={selectAll}
              onChange={handleToggleSelectAll}
            />
            <label htmlFor="selectAllHeader"></label>
          </div>
        </div>
      ),
      cell: (row) => (
        <div className="full-text-toggle custom_check-box">
          <div className="check-box no-strike">
            <input
              type="checkbox"
              id={`selectRow-${row.accountCode}`}
              checked={
                row.alreadyQueued ||
                selectedAccountsInternal.some(
                  (acc) => acc.accountCode === row.accountCode
                )
              }
              disabled={row.alreadyQueued}
              onChange={() => handleToggleAccount(row)}
            />
            <label htmlFor={`selectRow-${row.accountCode}`}></label>
          </div>
        </div>
      ),
    },
    {
      name: t("account_code_txt"),
      selector: (row) => row.accountCode || "-",
      sortable: true,
    },
    {
      name: t("account_name_txt"),
      selector: (row) => row.accountName || "-",
      sortable: true,
    },
    {
      name: t("email_address_txt"),
      selector: (row) => row.accountEmail || "-",
      sortable: true,
    },
    {
      name: t("last_login_txt"),
      selector: (row) => moment(row.lastLogin).format("DD/MM/YYYY"),
      sortable: false,
    },
    {
      name: t("already_queued_email_txt"),
      selector: (row) => {
        const hasSentEmails =
          row.totalEmailSentCount > 0 || row.alreadyQueued != false;
        const statusText = hasSentEmails ? t("queued_email_details_txt") : "";
        const handleClick = (e) => {
          if (!hasSentEmails) return;
          e.preventDefault();
          handleQueuedClick(row.accountCode);
        };
        return (
          <a
            href="#"
            className={`title-tooltip title-up ${hasSentEmails ? "button" : ""}`}
            data-title={hasSentEmails ? statusText : ""}
            onClick={handleClick}
            style={{
              cursor: hasSentEmails ? "pointer" : "default",
              pointerEvents: hasSentEmails ? "auto" : "none",
            }}
          >
            {row.alreadyQueued ? (
              <span className="price-ord-yes">
                <i className="fa fa-check" aria-hidden="true"></i>
              </span>
            ) : (
              <span className="price-ord-no">
                <i className="fa fa-times" aria-hidden="true"></i>
              </span>
            )}
          </a>
        );
      },
    },
    {
      name: t("email_last_sent_at_txt"),
      selector: (row) =>
        row.lastEmailSentDate
          ? dateformatwithuktime(row.lastEmailSentDate)
          : "",
    },
    {
      name: t("reminder_count_txt"),
      selector: (row) =>
        row.totalEmailSentCount !== undefined && row.totalEmailSentCount > 0
          ? row.totalEmailSentCount
          : "",
      sortable: true,
    },
  ];
  const handleAddSelectedCustomers = () => {
    if (selectedAccountsInternal.length === 0) {
      setAlerterrMessage([t("atleast_one_cus_need_for_statusupadte_txt")]);
      setAlertErrorPopup(true);
      return;
    }
    // Add selected customers to main table
    setSelectedAccounts((prev) => {
      const newOnes = selectedAccountsInternal
        .filter(
          (sel) => !prev.some((item) => item.accountCode === sel.accountCode)
        )
        .map((sel) => ({
          accountCode: sel.accountCode,
          accountName: sel.accountName,
          toEmail: sel.accountEmail || "",
        }));
      return [...prev, ...newOnes];
    });
    // Remove added customers from popup list
    setCustomerList((prevList) =>
      prevList.filter(
        (cust) =>
          !selectedAccountsInternal.some(
            (sel) => sel.accountCode === cust.accountCode
          )
      )
    );
    // Clear popup selections & close popup
    setSelectedAccountsInternal([]);
    setSelectAll(false);
    setShowCustomerPopup(false);
  };
  // Fetch previous campaign details via account code
  const handleQueuedClick = async (accountCode) => {
    setSelectedAccountCode(accountCode);
    setQueuedLoading(true);
    setShowQueuedPopup(true);
    try {
      const res = await http.post(
        BaseUrl + "admin/getEmailCampaignLogsbyAccountCode",
        { accountCode }
      );
      const rawData = res.data?.data || [];
      const formatted = rawData.map((item) => ({
        campaignName: item.campaignName || "-",
        emailType: item.emailType || "-",
        autoEmail: item.autoEmail ?? "-",
        runStatus: item.runStatus || "-",
        customerRunStatus: item.lastCustomerRunStatus || "-",
        emailSentStatus: item.lastCustomerSentStatus || "-",
        scheduledSendTime: item.lastScheduledSendTime || null,
        emailSentDate: item.lastCustomerSentDate || null,
        emailSentCount: item.totalSent ?? "-",
      }));
      const sortedData = formatted.sort((a, b) => {
        const order = { run: 1, pause: 2, stop: 3 };
        return (order[a.runStatus] || 999) - (order[b.runStatus] || 999);
      });
      setQueuedPopupData(sortedData);
    } catch (err) {
      console.error(err);
      setQueuedPopupData([]);
    }
    setQueuedLoading(false);
  };
  // Close and reset popup when main filters or email type changes
  useEffect(() => {
    setShowQueuedPopup(false);
    setQueuedPopupData(null);
  }, [emailType]);
  // Helper fot date format
  const formatSafe = (date) => {
    if (!date) return "-";
    const formatted = dateformatwithuktime(date);
    return formatted === "Invalid date" ? "-" : formatted;
  };
  const queuedColumns = [
    {
      name: t("campaign_namee_txt"),
      selector: (row) => row.campaignName || "-",
      sortable: true,
    },
    {
      name: t("email_type_txt"),
      selector: (row) =>
        row.emailType === "logged_in_not_order"
          ? t("logged_in_ordered_email_txt")
          : row.emailType === "logged_in_not_order_cutoff"
          ? t("logged_in_ordered_email_cutoff_txt")
          : row.emailType === "abandoned_cart"
          ? t("abandoned_cart_email_txt")
          : row.emailType,
      sortable: true,
    },
    {
      name: `${t("campaign_mode_txt")} / ${t("status_txt")}`,
      selector: (row) => {
        const mode = row.autoEmail ? "Auto" : "Manual";
        const status =
          row.runStatus === "run"
            ? t("running_txt")
            : row.runStatus === "pause"
            ? t("paused_txt")
            : row.runStatus === "stop"
            ? t("completed_txt")
            : row.runStatus || "-";

        return `${mode} / ${status}`;
      },
      sortable: true,
    },
    // {
    //   name: t("reminder_limit_txt"),
    //   selector: (row) => row.reminderCountLimit ?? "-",
    //   sortable: true,
    // },
    {
      name: t("reminder_count_txt"),
      selector: (row) =>
        row.emailSentCount && row.emailSentCount > 0 ? row.emailSentCount : "-",
      sortable: true,
    },
    {
      name: t("last_email_sent_date"),
      selector: (row) =>
        row.emailSentCount > 0 && row.emailSentDate
          ? formatSafe(row.emailSentDate)
          : "-",
    },
    {
      name: t("email_status_txt"),
      selector: (row) =>
        row.emailSentStatus
          ? row.emailSentStatus.charAt(0).toUpperCase() +
            row.emailSentStatus.slice(1)
          : "-",
    },
    {
      name: t("scheduled_date_txt"),
      selector: (row) =>
        row.emailSentStatus?.toLowerCase() === "pending" &&
        row.scheduledSendTime
          ? formatSafe(row.scheduledSendTime)
          : "-",
    },
  ];

  const showDeletePopup = (row) => {
    if (selectedAccounts.length <= 1) {
      // Show "minimum one customer" alert
      setShowMinCustomerAlert(true);
      return;
    }
    setRowToDelete(row);
    setShowDeleteConfirm(true);
  };
  // --- Confirm Delete ---
  const confirmDelete = () => {
    if (!rowToDelete) return;

    // Remove the selected row from the main table list
    const updatedAccounts = selectedAccounts.filter(
      (account) => account.accountCode !== rowToDelete.accountCode
    );

    setSelectedAccounts(updatedAccounts); // update table
    setShowDeleteConfirm(false); // close confirmation popup
    setRowToDelete(null); // reset
  };

  // --- Table columns ---
  const columns = [
    ...(bulkMode
      ? [
          {
            name: (
              <div className="full-text-toggle custom_check-box">
                <div className="check-box no-strike">
                  <input
                    type="checkbox"
                    id="bulkSelectAll"
                    checked={
                      selectedCustomerIds.length === selectedAccounts.length &&
                      selectedAccounts.length > 0
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedCustomerIds(
                          selectedAccounts
                            .filter((item) => item.customerStatus === "active")
                            .map((item) => item._id)
                        );
                      } else {
                        setSelectedCustomerIds([]);
                      }
                    }}
                  />
                  <label htmlFor="bulkSelectAll"></label>
                </div>
              </div>
            ),
            cell: (row) => (
              <div className="full-text-toggle custom_check-box">
                <div className="check-box no-strike">
                  <input
                    type="checkbox"
                    id={`bulkSelect-${row._id}`}
                    checked={selectedCustomerIds.includes(row._id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedCustomerIds((prev) => [...prev, row._id]);
                      } else {
                        setSelectedCustomerIds((prev) =>
                          prev.filter((id) => id !== row._id)
                        );
                      }
                    }}
                    disabled={row.customerStatus !== "active"}
                  />
                  <label htmlFor={`bulkSelect-${row._id}`}></label>
                </div>
              </div>
            ),
            width: "60px",
          },
        ]
      : []),
    {
      name: t("account_code_txt"),
      selector: (row) => row.accountCode,
      sortable: true,
    },
    {
      name: t("account_name_txt"),
      selector: (row) => row.accountName,
      sortable: true,
    },
    {
      name: t("email_address_txt"),
      selector: (row) => row.toEmail,
      sortable: true,
    },
    // Show these only if NOT draft
    ...(emailData.status !== "draft"
      ? [
          {
            name: t("email_last_sent_at_txt"),
            selector: (row) =>
              row.lastSentDate ? dateformatwithuktime(row.lastSentDate) : "-",
          },
          {
            name: t("reminder_count_txt"),
            selector: (row) =>
              row.EmailSentCount !== undefined && row.EmailSentCount !== null
                ? row.EmailSentCount === 0
                  ? "-"
                  : row.emailSentStatus === "bounced"
                  ? row.EmailSentCount > 0
                    ? row.EmailSentCount
                    : "-"
                  : row.EmailSentCount
                : "-",
            sortable: true,
          },
          {
            name: t("customer_activity_txt"),
            selector: (row) => {
              if (row?.customerStatus) {
                let dispalyStatus = row.customerStatus;
                let status = row.customerStatus;

                if (status === "deactive") {
                  dispalyStatus = t("deactivated_txt");
                } else if (status === "website_access_disabled") {
                  dispalyStatus = t("website_access_disabled_txt");
                } else if (status === "reminder_limit_reached") {
                  dispalyStatus = t("completed_txt");
                } else if (status === "unsubscribed") {
                  dispalyStatus = t("unsubscribed_txt");
                } else if (row.emailSentStatus === "bounced") {
                  dispalyStatus = t("bounced_txt");
                } else if (status === "restricted_account") {
                  dispalyStatus = t("restricted_account_status_txt");
                } else if (status === "cart_empty") {
                  dispalyStatus = t("cart_empty_txt");
                } else if (status === "no_empty_cart") {
                  dispalyStatus = t("no_empty_cart_txt");
                } else if (status === "active" && row.runStatus === "pause") {
                  dispalyStatus = t("pause_txt");
                } else if (status === "active" && row.runStatus === "run") {
                  dispalyStatus = t("running_txt");
                }
                const isNew =
                  (!row.lastSentDate || row.lastSentDate === "") &&
                  (!row.EmailSentCount || row.EmailSentCount === 0) &&
                  row.customerStatus === "active";
                if (isNew) {
                  dispalyStatus += ` (${t("new_txt")})`;
                } else {
                  // Only append (Stopped) if not new
                  const shouldAppendStopped =
                    status !== "reminder_limit_reached" &&
                    !(status === "active" && row.runStatus === "run");
                  if (shouldAppendStopped) dispalyStatus += ` (${t("stopped_txt")})`;
                }
                // let runStatus = "Run";
                // if (
                //   status === t("deactivated_txt") ||
                //   status === t("website_access_disabled_txt") ||
                //   status === t("reminder_limit_reached_txt")
                // ) {
                //   runStatus = "Completed";
                // } else if (row.runStatus === "pause") {
                //   runStatus = "Paused";
                // } else if (emailData.runStatus === "stop") {
                //   runStatus = "Completed";
                // }
                return (
                  dispalyStatus.charAt(0).toUpperCase() + dispalyStatus.slice(1)
                );
                // return `${
                //   row.runStatus.charAt(0).toUpperCase() + row.runStatus.slice(1)
                // } (${status.charAt(0).toUpperCase() + status.slice(1)})`;

                // return row.runStatus(
                //   `${
                //     status.charAt(0).toUpperCase() + status.slice(1)
                //   } (${status})`
                // );
              }
              return "-";
            },
            sortable: true,
          },
        ]
      : []),
    ...(viewOnly === false && emailData.status !== "draft"
      ? [
          {
            name: t("action_txt_sing"),
            cell: (row) => {
              if (row.customerStatus === "active") {
                const isPaused = row.runStatus === "run";
                const statusIcon = isPaused ? "fa-pause" : "fa-play";
                const statusTitle = isPaused ? t("pause_txt") : t("start_txt");
                return (
                  <div style={{ display: "flex", gap: "5px" }}>
                    {/* pause status */}
                    <a
                      className="button title-tooltip title-up"
                      data-title={statusTitle}
                      style={{ color: "white" }}
                      onClick={() => {
                        setShowStatusConfirmPopup(true);
                        setEmailEntryId(row._id);
                      }}
                    >
                      <i className={`fa ${statusIcon}`} aria-hidden="true"></i>
                    </a>
                  </div>
                );
              } else {
                return <span>-</span>;
              }
            },
          },
        ]
      : []),
    ...(emailData.status === "draft"
      ? [
          {
            name: t("action_txt"),
            selector: (row) => {
              const isPaused = row.runStatus === "run";
              const statusIcon = isPaused ? "fa-pause" : "fa-play";
              const statusTitle = isPaused ? "Pause" : "Run";
              return (
                <div style={{ display: "flex", gap: "5px" }}>
                  {/* Edit */}
                  {/* <a
                                className="button title-tooltip title-up"
                                data-title="Edit"
                                style={{ color: "white" }}
                                onClick={() => handleShowEditCampaign(row)}
                            >
                                <i className="fa fa-pencil" aria-hidden="true"></i>
                            </a> */}
                  {/* Delete */}
                  <a
                    className="button title-tooltip title-up"
                    data-title={t("delete_txt")}
                    style={{ color: "white" }}
                    onClick={() => showDeletePopup(row)}
                  >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </a>
                  {/* Pause/Stop */}
                  {/* <a
                                className="button title-tooltip title-up"
                                data-title={statusTitle}
                                style={{ color: "white" }}
                                onClick={() => handleStatusClick(row)}
                            >
                                <i className={`fa ${statusIcon}`} aria-hidden="true"></i>
                            </a> */}
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const statusSummary = useMemo(() => {
    let running = 0;
    let completed = 0;
    let actionStopped = 0;
    let manualPause = 0;
    selectedAccounts.forEach((row) => {
      const status = row.customerStatus;
      const run = row.runStatus;
      if (status === "active" && run === "run") {
        running++;
      } else if (status === "reminder_limit_reached") {
        completed++;
      } else if (status === "active" && run === "pause") {
        manualPause++;
      } else {
        actionStopped++;
      }
    });
    return { running, completed, actionStopped, manualPause };
  }, [selectedAccounts]);
  // Get campaign status label
  const getCampaignStatusLabel = () => {
    const status = campaignData?.status;
    const runStatus = campaignData?.runStatus;
    if (status === "draft" && runStatus === "pause") return t("draft_txt");
    if (status === "scheduled" && runStatus === "stop")
      return t("completed_txt");
    if (status === "scheduled" && runStatus === "pause") return t("paused_txt");
    if (status === "scheduled" && runStatus === "run") return t("running_txt");
    return "";
  };
  // --- Handlers ---
  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  const toggleEmailAccordion = () => setIsEmailAccordionOpen((prev) => !prev);
  const toggleReminderAccordion = () =>
    setIsReminderAccordionOpen((prev) => !prev);
  const handleConfirmAction = (type) => {
    setConfirmActionType(type);
    const { isValid, openAccordions } = formvalidation(type);
    setCampaignNameError("");
    if (!emailCampaignName || emailCampaignName.trim() === "") {
      setCampaignNameError(t("field_require_txt"));
      setTimeout(() => {
        const firstError = document.querySelector(".error-msg");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstError.classList.add("highlight-error");
          setTimeout(
            () => firstError.classList.remove("highlight-error"),
            2000
          );
        }
      }, 100);
      return;
    }
    if (!isValid) {
      if (openAccordions.primary) setIsEmailAccordionOpen(true);
      if (openAccordions.reminder) setIsReminderAccordionOpen(true);
      setTimeout(() => {
        const firstError = document.querySelector(".error-msg");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstError.classList.add("highlight-error");
          setTimeout(
            () => firstError.classList.remove("highlight-error"),
            2000
          );
        }
      }, 100);
      return;
    }
    setConfirmActionType(type);
    setShowConfirmPopup(true);
  };

  const handleStatusClick = (row) => {
    const isPaused = row.runStatus === "pause";
    const message = isPaused
      ? "Are you sure you want to stop sending the email to this customer? The email will not be sent."
      : "Are you sure you want to resume sending the email to this customer? The email will be sent.";
    setStatusPopup({
      show: true,
      row: row,
      message: message,
    });
  };

  const formvalidation = (actionType) => {
    let errmsg = {};
    let isValid = true;
    let openAccordions = { primary: false, reminder: false };
    if (!selectedAccounts || selectedAccounts.length === 0) {
      errmsg.accountCodes = t("select_atleast_one_customer");
      isValid = false;
    }
    if (!emailData.emailSubject) {
      errmsg.emailSubject = t("field_require_txt");
      isValid = false;
      openAccordions.primary = true;
    }
    if (!emailData.emailContent) {
      errmsg.emailContent = t("field_require_txt");
      isValid = false;
      openAccordions.primary = true;
    }
    if (showReminderEmail) {
      if (!isCustomInterval) {
        if (
          !reminderInterval ||
          reminderInterval === 0 ||
          reminderInterval === ""
        ) {
          errmsg.reminderInterval = t("field_require_txt");
          isValid = false;
          openAccordions.reminder = true;
        }
      } else {
        if (
          !customIntervalValue ||
          customIntervalValue === 0 ||
          customIntervalValue === ""
        ) {
          errmsg.customReminderInterval = t("field_require_txt");
          isValid = false;
          openAccordions.reminder = true;
        }
      }
      if (!emailData.reminderEmailSubject) {
        errmsg.reminderEmailSubject = t("field_require_txt");
        isValid = false;
        openAccordions.reminder = true;
      }
      if (!emailData.reminderEmailContent) {
        errmsg.reminderEmailContent = t("field_require_txt");
        isValid = false;
        openAccordions.reminder = true;
      }
    }
    if (showReminderEmail && selectedAccounts?.length > 0) {
      if (reminderCountLimit === "") {
        errmsg.reminderCountLimit = t("field_require_txt");
        isValid = false;
        openAccordions.reminder = true;
      } else if (
        reminderCountLimit !== "" &&
        reminderCountLimit < currentReminderCountforLimit
      ) {
        errmsg.reminderCountLimit = t("reminder_limit_exceed_error_txt", {
          currentReminderCount: currentReminderCountforLimit - 1,
        });
        isValid = false;
        openAccordions.reminder = true;
      }
    }
    // schedule datetime validation
    if (actionType === "send") {
      if (!scheduledDateTime) {
        setDateTimeError(t("please_select_schedule_date_time_txt"));
        isValid = false;
        // return { isValid, openAccordions };
      } else {
        const now = new Date();
        if (scheduledDateTime <= now) {
          setDateTimeError(t("scheduled_date_time_must_be_future_txt"));
          isValid = false;
          // return { isValid, openAccordions };
        } else {
          setDateTimeError("");
        }
      }
    } else {
      // For drafts, only validate if a date is chosen
      if (scheduledDateTime) {
        const now = new Date();
        if (scheduledDateTime <= now) {
          setDateTimeError(t("scheduled_date_time_must_be_future_txt"));
          isValid = false;
        } else {
          setDateTimeError("");
        }
      } else {
        setDateTimeError("");
      }
    }
    setErrors(errmsg);
    return { isValid, openAccordions };
  };
  const handleSubmitCampaign = async () => {
    setIsLoading(true);
    setSubmitLoading(true);
    setShowConfirmPopup(false);
    //console.log(emailData.status, "email data status");
    // Map action type to status
    let payloadStatus = "draft";
    if (confirmActionType === "send") {
      payloadStatus = "scheduled";
    } else if (confirmActionType === "draft") {
      payloadStatus = "draft";
    }
    //console.log(selectedAccounts, "selected accounts");
    let newSelectedAccounts = [...selectedAccounts];
    if (emailData.status === "draft" && confirmActionType === "send") {
      newSelectedAccounts = selectedAccounts.map((account) => ({
        ...account,
        runStatus: "run",
      }));
    }
    const baseEmailData = {
      emailCampaignId: campaignId,
      emailSubject: emailData.emailSubject,
      emailContent: emailData.emailContent,
      emailType,
      cutoffTime: customHoursFilter || accountFilter,
      reminderEmailSubject: emailData.reminderEmailSubject || "",
      reminderEmailContent: emailData.reminderEmailContent || "",
      reminderInterval: showReminderEmail ? reminderInterval : 0,
      reminderCountLimit: showReminderEmail ? reminderCountLimit : 0,
      header: sendHeader,
      footer: sendFooter,
      scheduledSendTime: scheduledDateTime
        ? scheduledDateTime.toISOString()
        : null,
      status: payloadStatus,
      runStatus:
        confirmActionType === "send" && emailData.status === "draft"
          ? "run"
          : "pause",
    };
    const fullEmailEntries = newSelectedAccounts.map((acc) => {
      // If existing entry already has extra fields (like _id, sentStatus), preserve them
      return {
        ...acc, // keep existing data
        ...baseEmailData, // merge shared campaign data
        runStatus: acc.runStatus,
        toEmail: acc.toEmail || acc.accountEmail,
      };
    });
    // Build payload
    const payload = {
      _id: campaignId,
      emailCampaignName,
      emailType,
      cutoffTime: customHoursFilter || accountFilter,
      emailEntries: fullEmailEntries,
      emailSubject: emailData.emailSubject,
      emailContent: emailData.emailContent,
      reminderEmailSubject: emailData.reminderEmailSubject || "",
      reminderEmailContent: emailData.reminderEmailContent || "",
      reminderInterval: showReminderEmail ? reminderInterval : 0,
      reminderCountLimit: showReminderEmail ? reminderCountLimit : 0,
      header: sendHeader,
      footer: sendFooter,
      scheduledSendTime: scheduledDateTime
        ? scheduledDateTime.toISOString()
        : null,
      status: payloadStatus,
      runStatus:
        confirmActionType === "send" && emailData.status === "draft"
          ? "run"
          : "pause",
      autoEmail: emailData?.autoEmail || false,
    };
    try {
      const url = `${BaseUrl}admin/editEmailCampaign`;
      const res = await http.put(url, payload);
      if (res.data.success) {
        if (res.data.message.startsWith("Pending emails")) {
          setAlerterrMessage(res.data.message);
          setAlertErrorPopup(true);
        } else {
          const actionText =
            payloadStatus === "scheduled" && emailData.status === "draft"
              ? t("scheduled_txt")
              : payloadStatus === "scheduled" &&
                emailData.status === "scheduled"
              ? t("updated_txt")
              : t("saved_as_draft_txt");
          setAlertMessage(
            t("email_campaign_status_msg", {
              action: actionText,
            })
          );
          setAlertPopup(true);
          if (confirmActionType === "send" && emailData.status === "draft") {
            setRedirectPath({
              path: "/email-logs",
              state: { activeTab: "Email Scheduled" },
            });
          } else {
            setRedirectPath("/email-campaign");
          }
        }
      } else {
        setAlerterrMessage(t("failed_to_update_campaign_txt"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      console.error(err);
      setAlerterrMessage(t("something_went_wrong_txt"));
      setAlertErrorPopup(true);
    } finally {
      setIsLoading(false);
      setSubmitLoading(false);
    }
  };

  // const handleConfirmStatus = (row) => {
  //     setIsLoading(true);
  //     const newStatus = row.runStatus === "pause" ? "stop" : "pause";
  //     http.post(`${BaseUrl}admin/updateCampaignStatus`, {
  //         campaignId: row._id,
  //         runStatus: newStatus,
  //     }).then(res => {
  //         if (res.data.success) {
  //             setSelectedAccounts(prev =>
  //                 prev.map(acc => acc._id === row._id ? { ...acc, runStatus: newStatus } : acc)
  //             );
  //         } else {
  //             setAlerterrMessage("Failed to update status");
  //             setAlertErrorPopup(true);
  //         }
  //     }).catch(() => {
  //         setAlerterrMessage("Something went wrong");
  //         setAlertErrorPopup(true);
  //     }).finally(() => {
  //         setIsLoading(false);
  //         setStatusPopup({ show: false, row: null, message: "" });
  //     });
  // };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const formatHoursToDays = (hours) => {
    if (!hours || isNaN(hours)) return "";
    const totalHours = parseInt(hours, 10);
    const days = Math.floor(totalHours / 24);
    const remaining = totalHours % 24;
    let result = "";
    if (days > 0) {
      result += `${days} day${days > 1 ? "s" : ""}`;
    }
    if (remaining > 0) {
      if (result) result += " ";
      result += `${remaining} hour${remaining > 1 ? "s" : ""}`;
    }
    return result || "0 hours";
  };

  const handleUpdateEmailEntryStatus = () => {
    if (!emailEntryId) return;

    const entry = selectedAccounts.find((acc) => acc._id === emailEntryId);
    if (!entry) {
      return;
    }
    const newStatus = entry.runStatus === "pause" ? "run" : "pause";
    const updated = selectedAccounts.map((item) =>
      item._id === emailEntryId
        ? { ...item, runStatus: newStatus } // update here
        : item
    );
    setSelectedAccounts(updated);
    setShowStatusConfirmPopup(false);
    setEmailEntryId("");
  };
  const handleBulkStatusUpdate = () => {
    const updatedAccounts = selectedAccounts.map((item) => {
      if (selectedCustomerIds.includes(item._id)) {
        return {
          ...item,
          runStatus: item.runStatus === "run" ? "pause" : "run",
        };
      }
      return item;
    });
    setSelectedAccounts(updatedAccounts);
    setShowBulkStatusPopup(false);
    setBulkMode(false);
    setSelectedCustomerIds([]);
  };

  // const currentReminderCount =
  //   selectedAccounts?.length > 0
  //     ? Math.max(...selectedAccounts.map((acc) => acc.reminderCount || 0)) - 2
  //     : -1;
  // console.log(currentReminderCount, "current reminder count");

  const handleEmailTypeChange = async (newType) => {
    if (!hasUserModified) setHasUserModified(true);
    setEmailType(newType);
    setPendingFilter("");
    setPendingCustomHours("");
    setAccountFilter("");
    setCustomHoursFilter("");
    setFilter("");
    setSelectedAccounts([]);
    // Clear primary email data
    setEmailData((prev) => ({
      ...prev,
      emailSubject: "",
      emailContent: "",
      reminderEmailSubject: "",
      reminderEmailContent: "",
    }));
    // Clear reminder
    setReminderInterval(null);
    setCustomIntervalValue("");
    setShowReminderEmail(false);
    setIsCustomInterval(false);
    // Clear original reminder
    setOriginalReminderData({
      reminderEmailSubject: "",
      reminderEmailContent: "",
      reminderInterval: 0,
      reminderCountLimit: 0,
      header: false,
      footer: false,
    });
    // Fetch new configuration
    await fetchEmailConfig(newType);
  };

  const fetchEmailConfig = async (selectedType) => {
    try {
      const response = await http.get(BaseUrl + "admin/emailConfigs");
      if (!response.data.success) return;
      const activeConfigs = response.data.data.filter(
        (item) => item.status === "active"
      );
      const config = activeConfigs.find(
        (item) => item.emailType === selectedType
      );
      if (!config) {
        clearFormData();
        clearEmailFormData();
        return;
      }
      setEmailData((prev) => ({
        ...prev,
        emailSubject: config.emailSubject || "",
        emailContent: config.emailContent || "",
        reminderEmailSubject: config.reminderEmailSubject || "",
        reminderEmailContent: config.reminderEmailContent || "",
      }));
      setSendHeader(config.header || false);
      setSendFooter(config.footer || false);
      const defaultIntervals = [24, 48, 96];
      const interval = Number(config.reminderInterval) || 0;
      if (!defaultIntervals.includes(interval)) {
        setIsCustomInterval(true);
        setReminderInterval(interval);
        setCustomIntervalValue(interval);
      } else {
        setIsCustomInterval(false);
        setReminderInterval(interval);
        setCustomIntervalValue("");
      }
      // --- REMINDER LIMIT ---
      setReminderCountLimit(Number(config.reminderCountLimit) || 0);
      // update originalReminderData config values
      setOriginalReminderData({
        reminderEmailSubject: config.reminderEmailSubject || "",
        reminderEmailContent: config.reminderEmailContent || "",
        reminderInterval: interval,
        reminderCountLimit: config.reminderCountLimit,
        header: config.header || false,
        footer: config.footer || false,
      });
      // --- CUTOFF TIME ---
      if (config.cutoffTime) {
        if (config.cutoffTime === "custom" || Number(config.cutoffTime) > 96) {
          setPendingFilter("custom");
          setPendingCustomHours(config.cutoffTime);
          setAccountFilter("custom");
          setCustomHoursFilter(config.cutoffTime);
        } else {
          setPendingFilter(Number(config.cutoffTime));
          setPendingCustomHours("");
          setAccountFilter(Number(config.cutoffTime));
          setCustomHoursFilter("");
        }
      }
    } catch (err) {
      console.error("Fetch email config failed:", err);
    }
  };
  // Disable Refresh when no emailType selected OR no pendingFilter chosen OR (custom selected but invalid)
  const isCustomInvalid =
    pendingFilter === "custom" &&
    (!pendingCustomHours ||
      String(pendingCustomHours).trim() === "" ||
      isNaN(pendingCustomHours) ||
      Number(pendingCustomHours) <= 0);
  const isRefreshDisabled =
    !emailType || pendingFilter === "" || isCustomInvalid;

  const cutoffUnchanged =
    accountFilter === originalCutoff || customHoursFilter === originalCutoff;
  const unchanged = emailType === originalEmailType && cutoffUnchanged;

  const scheduleDatesMessage = useMemo(() => {
    if (!schedules || schedules.length === 0) return "";
    if (schedules.length > 0) {
      const message = schedules
        .map((date, index) => {
          const formattedDate = dateformatwithuktime(date);
          if (index === 0) {
            return `• ${t("initial_email_started_at")} ${formattedDate}`;
          }
          return `• ${t("reminder_email_started_at", {
            num: index,
          })} ${formattedDate}`;
        })
        .join("\n");

      return `${t("campaign_mail_start_times")}\n${message}`;
    }
  }, [schedules]);

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };
  let loadingbuffer = isLoading ? "loading-buffer" : "";

  return (
    <section className="dashboard-block">
      {alerterrorPopup && (
        // <ShowAlert title={t("alert_txt")} message={alerterrMessage} />
        <AlertPopup
          title={t("alert_txt")}
          message={t(alerterrMessage)}
          handleOk={() => setAlertErrorPopup(false)}
        />
      )}
      {alertPopup && (
        <CommonAlert
          title={t("alert_txt")}
          message={alertMessage}
          redirectTo={redirectPath}
        />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <div className="flex-title">
              <h1 className="checkout-title">
                {viewOnly
                  ? t("view_email_campaign_txt")
                  : t("edit_email_campaign_txt")}{" "}
                {`(${getCampaignStatusLabel()})`}
              </h1>
              <div className="back-btn">
                <button onClick={() => navigate("/email-campaign")}>
                  {t("back_btn_txt")}
                </button>
              </div>
            </div>
            <div className="right-table-outer-wrap">
              <div className="input-field form-field freeproduct-fieldset masterentry-fieldset">
                <div className={`logged-in-not-ordered-email-customers`}>
                  <form>
                    {/* Campaign Name */}
                    <div className="flex-bx-wrap col2">
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label>
                            {t("campaign_name_txt")}
                            <span className="color-red">*</span>
                          </label>
                          <input
                            type="text"
                            value={emailCampaignName}
                            onChange={(e) =>
                              setEmailCampaignName(e.target.value)
                            }
                            readOnly={!isDraft}
                          />
                          {campaignNameError && (
                            <div className="error-msg">{campaignNameError}</div>
                          )}
                        </div>
                      </div>
                      {/* Email Type */}
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label>
                            {t("email_type_txt")}
                            <span className="color-red">*</span>
                          </label>
                          <select
                            value={emailType}
                            onChange={(e) =>
                              handleEmailTypeChange(e.target.value)
                            }
                            disabled={!isDraft}
                          >
                            <option value="logged_in_not_order">
                              {t("logged_in_ordered_email_txt")}
                            </option>
                            <option value="logged_in_not_order_cutoff">
                              {t("logged_in_ordered_email_cutoff_txt")}
                            </option>
                            <option value="abandoned_cart">
                              {t("abandoned_cart_email_txt")}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    {/* Cutoff */}
                    <div className="flex-bx-wrap col2">
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label>
                            {t("cutoff_time_txt")}
                            {emailType && (
                              <>
                                {" - "}
                                {emailType === "logged_in_not_order" &&
                                  t("logged_in_ordered_email_txt")}
                                {emailType === "logged_in_not_order_cutoff" &&
                                  t("logged_in_ordered_email_cutoff_txt")}
                                {emailType === "abandoned_cart" &&
                                  t("abandoned_cart_email_txt")}
                              </>
                            )}
                            <span className="color-red">*</span>
                          </label>
                          {emailType && pendingFilter !== "" && (
                            <a
                              className="title-tooltip title-right switch-info"
                              data-title={t("click_fetch_btn_info")}
                            >
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </a>
                          )}
                          {/* SHOW DROPDOWN ONLY IN DRAFT */}
                          {isDraft ? (
                            <select
                              value={pendingFilter}
                              onChange={(e) => {
                                if (!hasUserModified) setHasUserModified(true);
                                setCustomHoursError("");
                                setSelectedAccounts([]);
                                const val =
                                  e.target.value === ""
                                    ? ""
                                    : e.target.value === "custom"
                                    ? "custom"
                                    : parseInt(e.target.value, 10);

                                setPendingFilter(val);

                                if (val !== "custom" && val !== "") {
                                  setPendingCustomHours("");
                                  setAccountFilter(val);
                                  setCustomHoursFilter("");
                                } else if (val === "") {
                                  setAccountFilter("");
                                  setCustomHoursFilter("");
                                  setSelectedAccounts([]);
                                  setFilter("");
                                  setCustomHours("");
                                }
                              }}
                              disabled={!emailType}
                            >
                              <option value="">{t("select_txt")}</option>
                              <option value={24}>
                                {t("hour_txt", { hoursAgo: 24 })}
                              </option>
                              <option value={48}>
                                {t("hour_txt", { hoursAgo: 48 })}
                              </option>
                              <option value={96}>
                                {t("hour_txt", { hoursAgo: 96 })}
                              </option>
                              <option value="custom">{t("custom_txt")}</option>
                            </select>
                          ) : (
                            /* NON-DRAFT SHOW READONLY VALUE */
                            <input
                              type="text"
                              value={customHoursFilter || accountFilter || "-"}
                              readOnly
                            />
                          )}
                        </div>
                      </div>
                      {/* CUSTOM INPUT WHEN CUSTOM SELECTED */}
                      {isDraft && pendingFilter === "custom" && (
                        <div className="flex-bx-item">
                          <div className="input-field">
                            <label>
                              {t("custom_hr_txt")}
                              <span className="color-red">*</span>
                            </label>
                            <input
                              type="number"
                              value={pendingCustomHours}
                              placeholder={t("custom_hrs_text")}
                              min="1"
                              onKeyDown={(e) => {
                                if (["-", "+", ".", "e", "E"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                setCustomHoursError("");
                                setSelectedAccounts([]);
                                const value = e.target.value;

                                if (
                                  value === "" ||
                                  (/^[0-9\b]+$/.test(value) &&
                                    Number(value) > 0)
                                ) {
                                  if (!hasUserModified)
                                    setHasUserModified(true);
                                  setPendingCustomHours(value);
                                  setCustomHoursFilter(value);
                                  setAccountFilter("custom");
                                }
                              }}
                              disabled={!emailType}
                            />
                            {customHoursError && (
                              <div className="error-msg">
                                {customHoursError}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    {/* REFRESH BUTTON ONLY IN DRAFT */}
                    {isDraft && (
                      <div className="flex-bx-wrap">
                        <div className="flex-bx-item">
                          <div className="input-field fetch-btn-wrap">
                            <button
                              type="button"
                              className={`button refresh-btn ${
                                isRefreshDisabled ? "disabled" : ""
                              }`}
                              onClick={() => {
                                setCustomHoursError("");
                                // If no filter selected reset & return
                                if (
                                  pendingFilter === "" ||
                                  pendingFilter === null
                                ) {
                                  setSelectedAccounts([]);
                                  setFilter("");
                                  setCustomHours("");
                                  setCustomHoursFilter("");
                                  setAccountFilter("");
                                  return;
                                }
                                // Handle custom validation
                                if (pendingFilter === "custom") {
                                  if (
                                    !pendingCustomHours ||
                                    String(pendingCustomHours).trim() === "" ||
                                    isNaN(pendingCustomHours) ||
                                    Number(pendingCustomHours) <= 0
                                  ) {
                                    setCustomHoursError(
                                      t("please_enter_hour_txt")
                                    );
                                    return;
                                  }
                                  setCustomHours(pendingCustomHours);
                                  setCustomHoursFilter(pendingCustomHours);
                                } else {
                                  setCustomHours("");
                                  setCustomHoursFilter("");
                                }
                                // Apply filter
                                setFilter(pendingFilter);
                                // Call API to refresh customer list
                                handleAddCustomer();
                              }}
                              disabled={isRefreshDisabled}
                            >
                              {t("refresh_txt")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="input-field">
                      <label htmlFor="autoEmail">{t("auto_email_txt")}</label>
                      <div className="switch-button">
                        <input
                          type="checkbox"
                          id="autoEmail"
                          name="autoEmail"
                          className="checkbox"
                          checked={emailData?.autoEmail}
                          // onChange={(e) => {
                          //   return;
                          // }}
                          onChange={(e) => {
                            if (emailData.status === "scheduled") {
                              return;
                            }
                            setEmailData((prev) => ({
                              ...prev,
                              autoEmail: e.target.checked,
                            }));
                          }}
                        />
                        <div className="knobs">
                          <span></span>
                        </div>
                        <div className="layer"></div>
                      </div>
                      <a
                        className="title-tooltip title-right switch-info"
                        data-title={t("switch_info_text")}
                      >
                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                      </a>
                    </div>
                    {/* Customers Table */}
                    <div
                      className={`table_overflow checkout-table ${
                        emailData.status !== "draft"
                          ? "email-campaign-run-pause"
                          : ""
                      } ${bulkMode ? " runpausebtn" : ""} ${loadingbuffer}`}
                    >
                      {emailData.status === "draft" && !hasUserModified && (
                        <div className="table-btn-wrap flex justify-end gap-10">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddCustomer}
                          >
                            {t("add_emailentry_btn_txt")}
                          </button>
                        </div>
                      )}
                      {viewOnly === false && emailData.status !== "draft" && (
                        <div className="table-btn-wrap flex justify-end gap-10">
                          {/* Bulk status */}
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              if (bulkMode) {
                                // When clicking second time open confirmation popup
                                if (selectedCustomerIds.length === 0) {
                                  setAlerterrMessage([
                                    t("select_atleast_one_customer"),
                                  ]);
                                  setAlertErrorPopup(true);
                                  return;
                                }
                                setShowBulkStatusPopup(true);
                              } else {
                                // Activate bulk mode
                                setBulkMode(true);
                              }
                            }}
                          >
                            {bulkMode
                              ? [t("bulk_update_btn")]
                              : [t("initiate_bulk_update_btn")]}
                          </button>
                        </div>
                      )}
                      {emailData.status !== "draft" && (
                        <div className="status-summary-text">
                          <strong>{t("email_campaign_txt")}:</strong>
                          <span className="auto-email-status status-running">
                            <i className="fa fa-play-circle"></i> {t("running_txt")}
                            : {statusSummary.running}
                          </span>
                          <span className="auto-email-status status-completed">
                            <i className="fa fa-check-circle"></i>{" "}
                            {t("completed_txt")}: {statusSummary.completed}
                          </span>
                          <span className="auto-email-status status-stopped">
                            <i className="fa fa-stop-circle"></i>{" "}
                            {t("action_stopped_txt")}:{" "}
                            {statusSummary.actionStopped}
                          </span>
                          <span className="auto-email-status status-paused">
                            <i className="fa fa-pause-circle"></i>{" "}
                            {t("manual_pause_txt")}: {statusSummary.manualPause}
                          </span>
                        </div>
                      )}
                      <DataTable
                        columns={columns}
                        noDataComponent={
                          <div className="no-records-found">
                            {t("no_record_txt")}
                          </div>
                        }
                        data={selectedAccounts}
                        keyField="_id"
                        pagination
                        paginationPerPage={25}
                        paginationRowsPerPageOptions={[25, 50, 75, 100]}
                        paginationComponentOptions={paginationComponentOptions}
                      />
                      {/* {errors.accountCodes && (
                        <div className="error-msg">{errors.accountCodes}</div>
                      )} */}
                    </div>
                    {/* Primary Email Accordion */}
                    <div className="accordion-box input-field">
                      <div
                        className={
                          isEmailAccordionOpen
                            ? "accordion-header show"
                            : "accordion-header"
                        }
                        onClick={toggleEmailAccordion}
                      >
                        <h2>
                          {t("primary_email_configuration_txt")}{" "}
                          {emailType && (
                            <>
                              (
                              {emailType === "logged_in_not_order" &&
                                t("logged_in_ordered_email_txt")}
                              {emailType === "logged_in_not_order_cutoff" &&
                                t("logged_in_ordered_email_cutoff_txt")}
                              {emailType === "abandoned_cart" &&
                                t("abandoned_cart_email_txt")}
                              )
                            </>
                          )}
                        </h2>
                        <span className="show-accordion"></span>
                      </div>
                      <div
                        className="accordion-body"
                        style={{
                          display: isEmailAccordionOpen ? "block" : "none",
                        }}
                      >
                        <div className="input-field">
                          <div className="note-text">
                            <strong>{t("default_email_content_note")}</strong>
                          </div>
                        </div>
                        <div className="input-field">
                          <label>
                            {t("email_subject_txt")}
                            <span className="color-red">*</span>
                          </label>
                          <input
                            type="text"
                            value={emailData.emailSubject || ""}
                            onChange={(e) => {
                              clearError("emailSubject");
                              setEmailData((prev) => ({
                                ...prev,
                                emailSubject: e.target.value,
                              }));
                            }}
                            readOnly={viewOnly || currentReminderCount >= 0}
                          />
                          {errors.emailSubject && (
                            <div className="error-msg">
                              {errors.emailSubject}
                            </div>
                          )}
                        </div>
                        <div className="input-field">
                          <label>
                            {t("email_content_txt")}
                            <span className="color-red">*</span>
                          </label>
                          <EmailDynamicContentInfo emailType={emailType} />
                          <br />
                          <RichTextEditor
                            key={currentReminderCount} // 🔥 forces re-render when count changes
                            emailContent={emailData.emailContent || ""}
                            handleChangeEmailContent={(value) => {
                              clearError("emailContent");
                              setEmailData((prev) => ({
                                ...prev,
                                emailContent: value,
                              }));
                            }}
                            readOnly={viewOnly || currentReminderCount >= 0}
                          />
                          {errors.emailContent && (
                            <div className="error-msg">
                              {errors.emailContent}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <br />
                    {/* Send Reminder Toggle & Accordion */}
                    <div className="input-field">
                      <label htmlFor="reminderEmail">
                        {t("send_reminder_email_txt")}
                      </label>
                      <div className="switch-button">
                        <input
                          type="checkbox"
                          id="reminderEmail"
                          name="reminderEmail"
                          className="checkbox"
                          checked={showReminderEmail}
                          onChange={(e) => {
                            if (viewOnly) return;
                            const checked = e.target.checked;
                            if (checked) {
                              setShowReminderEmail(true);
                              setReminderInterval(
                                originalReminderData.reminderInterval ?? 0
                              );
                              setReminderCountLimit(
                                originalReminderData.reminderCountLimit ?? 0
                              );
                              setEmailData((prev) => ({
                                ...prev,
                                reminderEmailSubject:
                                  originalReminderData.reminderEmailSubject ||
                                  "",
                                reminderEmailContent:
                                  originalReminderData.reminderEmailContent ||
                                  "",
                              }));
                              setReminderHeader(
                                originalReminderData.header || false
                              );
                              setReminderFooter(
                                originalReminderData.footer || false
                              );
                            } else {
                              setOriginalReminderData({
                                reminderEmailSubject:
                                  emailData.reminderEmailSubject || "",
                                reminderEmailContent:
                                  emailData.reminderEmailContent || "",
                                reminderInterval: reminderInterval || 0,
                                reminderCountLimit: reminderCountLimit || 0,
                                header: reminderHeader || false,
                                footer: reminderFooter || false,
                              });
                              setShowReminderEmail(false);
                            }
                          }}
                        />
                        <div className="knobs">
                          <span></span>
                        </div>
                        <div className="layer"></div>
                      </div>
                    </div>
                    {showReminderEmail && (
                      <div className="accordion-box input-field">
                        <div
                          className={
                            isReminderAccordionOpen
                              ? "accordion-header show"
                              : "accordion-header"
                          }
                          onClick={toggleReminderAccordion}
                        >
                          <h2>
                            {t("reminder_email_configuration_txt")}{" "}
                            {emailType && (
                              <>
                                (
                                {emailType === "logged_in_not_order" &&
                                  t("logged_in_ordered_email_txt")}
                                {emailType === "logged_in_not_order_cutoff" &&
                                  t("logged_in_ordered_email_cutoff_txt")}
                                {emailType === "abandoned_cart" &&
                                  t("abandoned_cart_email_txt")}
                                )
                              </>
                            )}
                          </h2>
                          <span className="show-accordion"></span>
                        </div>
                        <div
                          className="accordion-body"
                          style={{
                            display: isReminderAccordionOpen ? "block" : "none",
                          }}
                        >
                          <div className="input-field">
                            <div className="note-text">
                              <strong>{t("default_email_content_note")}</strong>
                            </div>
                          </div>
                          {/* Reminder Limit */}
                          <div className="flex-bx-wrap col3">
                            <div className="flex-bx-item">
                              <div className="input-field">
                                <label htmlFor="reminderCountLimit">
                                  {t("reminder_limit_txt")}
                                  <span className="color-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="reminderCountLimit"
                                  value={
                                    reminderCountLimit === 0
                                      ? ""
                                      : reminderCountLimit
                                  }
                                  placeholder={t("reminder_limit_text")}
                                  min="1"
                                  onKeyDown={(e) => {
                                    if (
                                      !/[0-9]/.test(e.key) &&
                                      ![
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Tab",
                                      ].includes(e.key)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    clearError("reminderCountLimit");
                                    const value = e.target.value;
                                    setReminderCountLimit(
                                      value === "" ? "" : Number(value)
                                    );
                                  }}
                                  readOnly={viewOnly}
                                />
                                {!viewOnly &&
                                  emailData.status === "scheduled" &&
                                  currentReminderCountforLimit > 1 && (
                                    <div className="note-text">
                                      {t("reminder_limit_note_txt", {
                                        currentReminderCount:
                                          currentReminderCountforLimit - 1,
                                      })}
                                      {/* Your reminder limit should be above the current reminder count to continue ({currentReminderCount}). */}
                                    </div>
                                  )}

                                {errors.reminderCountLimit && (
                                  <div className="error-msg">
                                    {errors.reminderCountLimit}
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* Reminder Interval */}
                            <div className="flex-bx-item">
                              <div className="input-field">
                                <label>
                                  {t("reminder_email_interval_txt")}
                                  {/* Only show days/hours note if interval >= 24 */}
                                  {/* {!isCustomInterval &&
                                    reminderInterval >= 24 && (
                                      <span className="note-text">
                                        {" - "}
                                        {formatHoursToDays(reminderInterval)}
                                      </span>
                                    )} */}
                                  <span className="color-red">*</span>
                                </label>

                                {/* Dropdown for preset values */}
                                <select
                                  value={
                                    isCustomInterval
                                      ? "custom"
                                      : reminderInterval || ""
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "") {
                                      // Placeholder selected
                                      setIsCustomInterval(false);
                                      setReminderInterval(""); // <-- Needed for edit mode
                                    } else if (val === "custom") {
                                      setIsCustomInterval(true);
                                      setReminderInterval(
                                        customIntervalValue || 0
                                      );
                                    } else {
                                      setIsCustomInterval(false);
                                      setReminderInterval(Number(val));
                                    }
                                    clearError("reminderInterval");
                                    clearError("customReminderInterval");
                                  }}
                                  disabled={viewOnly}
                                >
                                  <option value="">
                                    {t("select_interval_txt")}
                                  </option>
                                  {intervalOptions.map((opt) => (
                                    <option key={opt} value={opt}>
                                      {opt}
                                    </option>
                                  ))}
                                  <option value="custom">
                                    {t("custom_txt")}
                                  </option>
                                </select>
                                {errors.reminderInterval && (
                                  <div className="error-msg">
                                    {errors.reminderInterval}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Custom input */}
                            {isCustomInterval && (
                              <div className="flex-bx-item">
                                <div className="input-field">
                                  <label>
                                    {t("add_custom_hours_txt")}
                                    {/* Show note ONLY when in custom mode */}
                                    {/* {customIntervalValue >= 24 && (
                                      <span className="note-text">
                                        {" - "}
                                        {formatHoursToDays(customIntervalValue)}
                                      </span>
                                    )} */}
                                    <span className="color-red">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="1"
                                    value={customIntervalValue}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setCustomIntervalValue(
                                        val === "" ? "" : Number(val)
                                      );
                                      setReminderInterval(
                                        val === "" ? 0 : Number(val)
                                      );
                                      clearError("customReminderInterval");
                                    }}
                                    placeholder={t("custom_hrs_text")}
                                    readOnly={viewOnly}
                                  />
                                  {errors.customReminderInterval && (
                                    <div className="error-msg">
                                      {errors.customReminderInterval}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {/* Reminder Email Subject */}
                          <div className="input-field">
                            <label>
                              {t("reminder_email_subject_txt")}
                              <span className="color-red">*</span>
                            </label>
                            <input
                              type="text"
                              name="reminderEmailSubject"
                              value={emailData.reminderEmailSubject || ""}
                              onChange={(e) => {
                                clearError("reminderEmailSubject");
                                setEmailData((prev) => ({
                                  ...prev,
                                  reminderEmailSubject: e.target.value,
                                }));
                              }}
                              readOnly={viewOnly}
                            />
                            {errors.reminderEmailSubject && (
                              <div className="error-msg">
                                {errors.reminderEmailSubject}
                              </div>
                            )}
                          </div>
                          {/* Reminder Email Content */}
                          <div className="input-field">
                            <label>
                              {t("reminder_email_content_txt")}
                              <span className="color-red">*</span>
                            </label>
                            <EmailDynamicContentInfo emailType={emailType} />
                            <br />
                            <RichTextEditor
                              emailContent={
                                emailData.reminderEmailContent || ""
                              }
                              handleChangeEmailContent={(value) => {
                                clearError("reminderEmailContent");
                                setEmailData((prev) => ({
                                  ...prev,
                                  reminderEmailContent: value,
                                }));
                              }}
                              readOnly={viewOnly}
                            />
                            {errors.reminderEmailContent && (
                              <div className="error-msg">
                                {errors.reminderEmailContent}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Schedule Date */}

                    <div className="grid grid-cols-3 gap-md">
                      <div className="grid-item">
                        <div className="input-field">
                          <label>
                            {t("schedule_email_date_time_txt")}
                            {isScheduleRequired && (
                              <span className="color-red">*</span>
                            )}
                          </label>
                          {scheduledDateTime !== "" && scheduledDateTime !== null && (
                            <a
                              className="title-tooltip title-right switch-info w--tp-xl pre-line"
                              data-title={scheduleDatesMessage}
                              // style={{ whiteSpace: "pre-line" }}
                            >
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </a>
                          )}

                          <br />
                          <DatePicker
                            selected={scheduledDateTime}
                            onChange={(date) => {
                              // If user selects today and time is 00:00, set it to current time
                              const now = new Date();
                              if (
                                date &&
                                date.toDateString() === now.toDateString() &&
                                (!scheduledDateTime ||
                                  (scheduledDateTime.getHours() === 0 &&
                                    scheduledDateTime.getMinutes() === 0))
                              ) {
                                date.setHours(now.getHours());
                                date.setMinutes(now.getMinutes());
                              }
                              setScheduledDateTime(date);
                              if (date) setDateTimeError("");
                            }}
                            onChangeRaw={() => setDateTimeError("")}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy HH:mm"
                            minDate={new Date()}
                            minTime={
                              scheduledDateTime &&
                              scheduledDateTime.toDateString() ===
                                new Date().toDateString()
                                ? new Date()
                                : new Date().setHours(0, 0, 0, 0)
                            }
                            maxTime={new Date().setHours(23, 45, 0, 0)}
                            placeholderText={t("date_time_placeholder_txt")}
                            /* 🔥 Disable Weekends + Holidays */
                            filterDate={(date) => {
                              const day = date.getDay();

                          // ❌ Disable Saturday and Sunday
                           if (day === 0 || day === 6) return false;

                          // ❌ Disable holidays loaded from API
                          const isHoliday = holidays.includes(
                            date.setHours(0, 0, 0, 0)
                          );

                          return !isHoliday;
                        }}
                        readOnly={viewOnly}
                      />
                      {dateTimeError && (
                        <div className="error-msg">{dateTimeError}</div>
                      )}
                    </div>
                      </div>
                      <div className="grid-item"></div>
                      <div className="grid-item">
                        {/* Created & Updated Date Info */}

                        <div className="flex-bx-wrap col2">
                          {/* Created On */}
                          <div className="flex-bx-item">
                            <div className="input-field">
                              <label style={{ fontWeight: 600 }}>
                                {t("created_on_txt")}
                              </label>
                              <div>
                                {emailData?.createdAt
                                  ? format(
                                      new Date(emailData.createdAt),
                                      "dd-MM-yyyy HH:mm"
                                    )
                                  : "-"}
                              </div>
                            </div>
                          </div>
                          {/* Updated On */}
                          <div className="flex-bx-item">
                            <div className="input-field">
                              <label style={{ fontWeight: 600 }}>
                                {t("updated_on_txt")}
                              </label>
                              <div>
                                {emailData?.updatedAt
                                  ? format(
                                      new Date(emailData.updatedAt),
                                      "dd-MM-yyyy HH:mm"
                                    )
                                  : "-"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="btnfield">
                      <div className="btnfield">
                        {!viewOnly && (
                          <>
                            {emailData.status !== "scheduled" && (
                              <button
                                type="button"
                                className="btn-draft"
                                onClick={() => {
                                  setIsScheduleRequired(false);
                                  handleConfirmAction("draft");
                                }}
                              >
                                {t("save_as_draft_btn_txt")}
                              </button>
                            )}
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn-send"
                              onClick={() => {
                                setIsScheduleRequired(true);
                                handleConfirmAction("send");
                              }}
                            >
                              {emailData?.status === "scheduled"
                                ? t("update_btn_txt")
                                : `${t("schedule_and_send_txt")}`}
                            </button>
                            &nbsp;&nbsp;
                          </>
                        )}
                        <button
                          type="button"
                          onClick={() => navigate("/email-campaign")}
                        >
                          {viewOnly ? t("back_btn_txt") : t("cancel_txt")}
                        </button>
                      </div>
                    </div>
                  </form>
                  {submitLoading && (
                    <div className="loading-full-bg">
                      <div className="loading-buffer"></div>
                    </div>
                  )}
                  {showDeleteConfirm && (
                    <ConfirmationPopup
                      title={t("remove_email_entry_txt")}
                      confirmationMessage={t("remove_email_confirm_txt")}
                      handleYes={confirmDelete}
                      handleNo={() => setShowDeleteConfirm(false)}
                    />
                  )}
                  {showConfirmPopup && (
                    <ConfirmationPopup
                      title={t("confirm_txt")}
                      confirmationMessage={
                        confirmActionType === "send" &&
                        emailData.status !== "scheduled" ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: t("sendmail_confirm_txt", {
                                count: selectedAccounts?.length || 0,
                              }),
                            }}
                          />
                        ) : confirmActionType === "send" &&
                          emailData.status === "scheduled" ? (
                          t("update_campaign_confirm_txt")
                        ) : (
                          t("draftmail_confirm_txt")
                        )
                      }
                      handleYes={handleSubmitCampaign}
                      handleNo={() => setShowConfirmPopup(false)}
                    />
                  )}
                  {showStatusConfirmPopup && (
                    <ConfirmationPopup
                      title={t("confirm_txt")}
                      confirmationMessage={t("run_pause_status_confirm_txt")}
                      handleYes={handleUpdateEmailEntryStatus}
                      handleNo={() => setShowStatusConfirmPopup(false)}
                    />
                  )}
                  {showBulkStatusPopup && (
                    <ConfirmationPopup
                      title={t("update_status_txt")}
                      confirmationMessage={t("run_pause_bulk_confirm_txt")}
                      handleYes={handleBulkStatusUpdate}
                      handleNo={() => setShowBulkStatusPopup(false)}
                    />
                  )}
                  {showMinCustomerAlert && (
                    <AlertPopup
                      title={t("alert_txt")}
                      message={t("last_cus_dlt_alert_txt")}
                      handleOk={() => setShowMinCustomerAlert(false)}
                    />
                  )}
                  {showCustomerPopup && (
                    <Popup
                      extClass="order-pop logged-in-notOrd-table"
                      closebtn={
                        <>
                          <div className="pop-header-top order-top">
                            <div className="head">
                              <h4>{t("select_emailentry_popup_title_txt")}</h4>
                            </div>
                            <span
                              onClick={() => setShowCustomerPopup(false)}
                              className="close"
                            ></span>
                          </div>
                        </>
                      }
                      bodyMoreTxt={
                        <>
                          <div className="modal-table">
                            {popupLoading ? (
                              <div className="loading-overlay">
                                <div className="loading-message">
                                  {t("loading_txt")}
                                </div>
                              </div>
                            ) : (
                              <div className="checkout-table">
                                <div className="table_overflow logged-in-notOrd-table">
                                  <DataTable
                                    columns={customerColumns}
                                    data={customerList}
                                    pagination
                                    progressPending={popupLoading}
                                    customStyles={customStyles}
                                    noDataComponent={
                                      <div className="no-records-found">
                                        {t("no_record_txt")}
                                      </div>
                                    }
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[
                                      25, 50, 75, 100,
                                    ]}
                                    paginationComponentOptions={
                                      paginationComponentOptions
                                    }
                                  />
                                  <div className="popup-footer text-right mt-3">
                                    <button
                                      className="theme-btn"
                                      onClick={handleAddSelectedCustomers}
                                      disabled={
                                        selectedAccountsInternal.length === 0
                                      }
                                    >
                                      {t("add_selected_entry_count", {
                                        selectedAccountsCount:
                                          selectedAccountsInternal.length,
                                      })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      }
                    />
                  )}
                  {showQueuedPopup && (
                    <Popup
                      extClass="order-pop campaign-list-pop"
                      closebtn={
                        <>
                          <div className="pop-header-top order-top">
                            <div className="head">
                              <h4>
                                {t("queued_email_details")}
                                {selectedAccountCode &&
                                  ` - ${selectedAccountCode}`}
                              </h4>
                            </div>
                            <span
                              onClick={() => setShowQueuedPopup(false)}
                              className="close"
                            ></span>
                          </div>
                        </>
                      }
                      bodyMoreTxt={
                        <>
                          <div className="modal-table">
                            {queuedLoading ? (
                              <div className="loading-overlay">
                                <div className="loading-message">
                                  {t("loading_txt")}
                                </div>
                              </div>
                            ) : (
                              <div className="checkout-table">
                                <div className="table_overflow">
                                  {queuedPopupData?.length > 0 ? (
                                    <DataTable
                                      columns={queuedColumns}
                                      data={queuedPopupData}
                                      pagination
                                      customStyles={customStyles}
                                      noDataComponent={
                                        <div className="no-records-found">
                                          {t("no_record_txt")}
                                        </div>
                                      }
                                      paginationPerPage={25}
                                      paginationRowsPerPageOptions={[
                                        25, 50, 75, 100,
                                      ]}
                                      paginationComponentOptions={
                                        paginationComponentOptions
                                      }
                                    />
                                  ) : (
                                    <div className="no-records-found">
                                      {t("no_record_txt")}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default EditEmailCampaign;
